import React, { ForwardedRef, PropsWithChildren, useRef } from 'react';
import { WideBanner } from '../WideBanner/WideBanner';
import { MegaphoneIcon } from '../../icons/megaphone';
import styles from './Announcement.module.scss';
import { CloseIcon } from '../../icons/close';
import { Button } from '../Button/Button';
import { IconButton } from '../Button/IconButton';
import cls from 'classnames';

export const Announcement = (props: PropsWithChildren<AnnouncementProps>) => {
  const ref = useRef<HTMLBaseElement>();
  const root = useRef<HTMLDivElement>(document.querySelector(':root'));

  // Some parts of the website layout is depending on the --navbar-height-offset
  // variable which needs to be recalculated once we add and remove stuff from
  // the navbar
  function recalculateoffset() {
    if (!root.current) {
      return;
    }

    const navbarHeight = ref.current?.getBoundingClientRect();
    if (navbarHeight !== undefined) {
      root.current.style.setProperty('--navbar-height-offset', `${navbarHeight.height + 60}px`);
    }
  }

  function resetOffset() {
    if (!root.current) {
      return;
    }

    root.current.style.setProperty(
      '--navbar-height-offset',
      root.current.style.getPropertyValue('--navbar-height'),
    );
  }

  React.useEffect(() => {
    recalculateoffset();
    return resetOffset;
  }, []);
  return (
    <WideBanner className={styles.announcement} ref={ref as ForwardedRef<any>}>
      <div className={styles.announcementText}>
        <div className={styles.megaphoneWrapper}>
          <MegaphoneIcon />
        </div>
        {props.children}
      </div>
      <div className={cls(styles.interactables, styles.mobileFullwidth)}>
        <a
          href={props.actionButtonLink.toString()}
          className={styles.mobileFullwidth}
          target="_blank"
          rel="nofollow noreferrer"
          // clicking on the link should be equivalent to dismissal
          onClick={() => props.onDismiss('interact')}
        >
          <Button small primary className={cls(styles.actionButton, styles.mobileFullwidth)}>
            {props.actionButtonText}
          </Button>
        </a>
        <IconButton icon={<CloseIcon />} onClick={() => props.onDismiss('close')} />
      </div>
    </WideBanner>
  );
};

export type AnnouncementDismissalReason = 'interact' | 'close';

export type AnnouncementProps = {
  actionButtonLink: URL;
  actionButtonText: string;
  onDismiss: (reason: AnnouncementDismissalReason) => void;
};
